import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, path } from 'ramda';

import { handleErrorBase, handleSuccessBase } from '../../util/forms';
import { isNilOrEmpty } from '../../util/redux';

import FormGroup from '../Forms/FormGroup';

class DiscountForm extends Component {
  static propTypes = {
    discount: PropTypes.object,
    checkDiscount: PropTypes.func,
    update: PropTypes.func,
  };

  state = {
    discountCode: '',
  };

  render() {
    const { discount, checkDiscount, update } = this.props;
    const { discountCode } = this.state;

    return (
      <FormGroup label="Discount Code (if applicable)" className="mt-4">
        <form className="input-group">
          <input
            className="form-control"
            value={discountCode}
            onChange={({ target }) =>
              this.setState({
                discountCode: target.value,
              })
            }
          />
          <div className="input-group-append">
            <button
              type="button"
              className="btn btn-primary btn-padded btn-not-round"
              onClick={(e) => {
                e.preventDefault();
                checkDiscount(discountCode)
                  .then(({ data }) => update(data))
                  .then(() => handleSuccessBase('Discount applied'))
                  .catch((err) => {
                    console.error(err);
                    const message = path(['response', 'data', 'message'], err);
                    handleErrorBase(isNilOrEmpty(message) ? 'Could not apply discount' : message);
                  });
              }}
            >
              Apply
            </button>
          </div>
        </form>
        {!isEmpty(discount) && (
          <div className="mt-3">
            <strong>Discount applied: </strong>
            {discount.code} (
            <button
              type="button"
              className="btn btn-link p-1"
              onClick={() =>
                checkDiscount(0)
                  .then(({ data }) => update(data))
                  .then(() => handleSuccessBase('Discount removed'))
                  .catch(() => handleErrorBase('Could not remove discount'))
              }
            >
              Remove
            </button>
            )
          </div>
        )}
      </FormGroup>
    );
  }
}

export default DiscountForm;
